import React from 'react';
import { GiftIcon } from 'lucide-react';
import { ModelIcon } from './ModelIcon';
import { kitContents } from '../data/kit';
import { getAccent } from '../utils/accent';
export function KitSummary() {
  return <section className="w-full bg-paper py-20 lg:py-24" aria-labelledby="en-total" data-id="element-191" data-mp="1e4t6xm302r4b">
      <div className="mx-auto max-w-3xl px-5" data-id="element-192" data-mp="1a2za5ovxe79f">
        <h2 id="en-total" className="text-center font-display text-3xl font-black tracking-tight sm:text-4xl" data-id="element-193" data-mp="1a40uyl2qu84c">
          En total recibís
        </h2>
        <ul className="mt-10 divide-y divide-line overflow-hidden rounded-3xl bg-surface shadow-[0_1px_0_#e3ddce]" data-id="element-194" data-mp="21t42qatua0lq">
          {kitContents.map(item => {
          const a = item.accent ? getAccent(item.accent) : null;
          return <li key={item.kind} className="flex items-center gap-4 px-5 py-4 sm:px-7" data-id="element-195" data-mp="1sus3jkewpuho">
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${a ? `${a.soft} ${a.text}` : 'bg-cta/20 text-cta-ink'}`} data-id="element-196" data-mp="mdwvmpwl8uj5">
                  {item.accent ? <ModelIcon accent={item.accent} data-id="element-197" data-mp="1rno2yj2o7fnb" /> : <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-198" data-mp="1rmmpy923gj2y" />}
                </span>
                <div className="min-w-0 flex-1" data-id="element-199" data-mp="1dn3jdkoxlfsr">
                  <p className="text-xs font-bold uppercase tracking-wider text-muted" data-id="element-200" data-mp="1in7yb6a6y2gv">{item.kind}</p>
                  <p className="font-display text-lg font-black text-ink" data-id="element-201" data-mp="13ybslfvlx1jf">{item.title}</p>
                  <p className="text-sm text-muted" data-id="element-202" data-mp="13wiitrpp6177">{item.detail}</p>
                </div>
              </li>;
        })}
        </ul>
        <p className="mt-8 text-center font-display text-2xl font-black text-brand sm:text-3xl" data-id="element-203" data-mp="uyoq0qr55pos">
          6 recursos digitales en un solo kit.
        </p>
      </div>
    </section>;
}